import initialState from './BranchesInitialState';
import reducers from './BranchesReducer';

export default {
  initialState,
  reducers,
};
